import { IonButton, IonList, IonRow, IonSpinner } from "@ionic/react";
import { ReactNode, useContext, useEffect, useState } from "react";
import { FilterContext } from '../State/FilterContext'
import { generateRandomString } from "../services/util";
import RankCardLeader from "./RankCardLeader";
import TournamentCard from "./TournamentCard";
import UserCard from "./UserCard";
import GroupCard from "./GroupCard";
import { useHistory } from "react-router-dom";

const GroupedSearchResults: React.FC<SearchResultsProps> = ({results, filters, searchType = "match" }) => {
  const [resultsList, setResultsList] = useState<ReactNode[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const {state, dispatch} = useContext(FilterContext);
  const history = useHistory();

  console.log("Group Saerch Result", results);
  console.log("group Saerch filter", filters);
  console.log("group Saerch Type", searchType);

  const sortedUsers = Object.values(results).sort((a, b) => {
    return b._matchingData.UsersSports.rank - a._matchingData.UsersSports.rank;
});
console.log("Sorted user Result", sortedUsers);

  // const listResults = () => {
  //   let list = [];
  //   for (const [name, group] of Object.entries(results)) {
  //     let items = [];
      
  //     if (searchType == "leaderboard"){
  //     console.log("search type cond", searchType);
  //     items = group.map((item: any) => (
  //       <RankCard user={item} filters={filters} key={generateRandomString()} />
  //     ));
  //   }

  //     if (group.map !== undefined){
  //        console.log("helllllllllllll");
        
  //     }
      
  //     let card = (
  //       <GroupCard title={name} key={generateRandomString()}>
  //         {items}
  //         <IonButton
  //           expand="full"
  //           onClick={() => {
	// 						dispatch({type: 'leaderboard_setSport', payload: name});
	// 					}}
  //         >
  //           View All111111111111
  //         </IonButton>
  //       </GroupCard>
  //     )
  //     list.push(card);
  //   }
  //   setIsLoading(false);
  //   return list;
  // }

  // useEffect(() => {
  //   setResultsList(listResults());
  // }, [results])


  const listResults = () => {
  const list: JSX.Element[] = [];

 for (const [name, group] of Object.entries(sortedUsers)) {

  console.log("Sport name:", name);
  console.log("Group:", group);

  let users: any[] = [];

  if (Array.isArray(group)) {
    users = group;
  } else if (group && typeof group === "object") {
    users = [group];
  }

  console.log("Users:", users);

  let items: JSX.Element[] = [];

  if (searchType === "leaderboard") {

    items = users.map((item: any, index: number) => (
      <RankCardLeader
        user={item}
        filters={filters}
        key={item.id ?? `${name}-${index}`}
      />
    ));
  }

  const card = (
    <GroupCard title={name} key={name}>

      {items}

      {/* <IonButton
        expand="full"
        onClick={() => {
          dispatch({
            type: "leaderboard_setSport",
            payload: name,
          });
        }}
      >
        VIEW ALL
      </IonButton> */}

    </GroupCard>
  );

  list.push(card);
}

  setIsLoading(false);
  return list;
};

useEffect(() => {
  setResultsList(listResults());
}, [results, searchType, filters]);

  return (
    (isLoading) ? (
    <IonRow className="ion-justify-content-center ion-align-items-center" style={{padding: '15px'}}>
      <IonSpinner
        style={{
          width: "100%",
          height: `30px`
        }}
        name="dots"
      />
    </IonRow>
  ):(
      <IonList>
        {resultsList}
      </IonList>
    )
  )
}

export default GroupedSearchResults